/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./reportWizardConfiguration.vue?vue&type=template&id=6b630fc0&scoped=true"
import script from "./reportWizardConfiguration.vue?vue&type=script&lang=js"
export * from "./reportWizardConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b630fc0",
  null
  
)

export default component.exports